import {
  Checkbox,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Theme,
  makeStyles
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import { useObserver } from 'mobx-react-lite';
import React, { FC } from 'react';
import OptionPrice from './OptionPrice';
import { OrderingModifier, OrderModifier, OrderingOption } from 'kiolyn-api';
import newOrderOption from '../../../domain/usecases/NewOrderOption';

const useStyles = makeStyles((theme: Theme) => ({
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));

interface EditSubModifierProps {
  modifier: OrderingModifier;
  option: OrderingOption;
  selectedModifiers?: OrderModifier[];
  onChange?: (modifiers: OrderModifier[]) => void;
}

const EditSubModifier: FC<EditSubModifierProps> = ({
  modifier,
  option,
  selectedModifiers,
  onChange
}) => {
  const classes = useStyles();

  const toggleSelection = (
    option: OrderingOption,
    suboption: OrderingOption
  ) => {
    const newModifiders = selectedModifiers || [];
    const selectedModifier = newModifiders.find(m => m.id === modifier.id);
    if (selectedModifier !== undefined) {
      const selectedOption = selectedModifier.options.find(
        o => o.id === option.id
      );
      if (
        selectedOption !== undefined &&
        selectedOption.suboptions !== undefined
      ) {
        const selectedSubOption = selectedOption.suboptions.find(
          sub => sub.id === suboption.id
        );
        if (option.required_level === 'exact_one') {
          selectedOption.suboptions = [];
          selectedOption.suboptions.push(newOrderOption(suboption));
        } else if (selectedSubOption === undefined) {
          selectedOption.suboptions.push(newOrderOption(suboption));
        } else {
          selectedOption.suboptions = selectedOption.suboptions.filter(
            sub => sub.id !== suboption.id
          );
        }
      }
    }
    if (onChange !== undefined) {
      onChange(newModifiders);
    }
  };

  const isSelected = (
    option: OrderingOption,
    suboption: OrderingOption
  ): boolean => {
    if (
      modifier === undefined ||
      selectedModifiers === undefined ||
      isEmpty(selectedModifiers)
    ) {
      return false;
    }
    const selectedModifier = selectedModifiers.find(m => m.id === modifier.id);
    if (
      selectedModifier === undefined ||
      selectedModifier.options === undefined
    ) {
      return false;
    }
    const selectedOption = selectedModifier.options.find(
      o => o.id === option.id
    );
    if (
      selectedOption === undefined ||
      selectedOption.suboptions === undefined
    ) {
      return false;
    }
    return (
      selectedOption.suboptions.find(sub => sub.id === suboption.id) !==
      undefined
    );
  };

  return useObserver(() => {
    if (option.suboptions === undefined) {
      return null;
    }
    return (
      <List disablePadding>
        {option.suboptions.map(suboption => (
          <ListItem
            key={suboption.id}
            className={classes.nested}
            button
            divider
            onClick={() => toggleSelection(option, suboption)}
          >
            <ListItemText
              primary={suboption.name}
              secondary={<OptionPrice price={suboption.price} />}
            />
            <ListItemSecondaryAction>
              <Checkbox
                edge="end"
                color="primary"
                checked={isSelected(option, suboption)}
                //onChange={() => toggleSelection(option, suboption)}
                onClick={() => toggleSelection(option, suboption)}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    );
  });
};
export default EditSubModifier;
